<template>
        <b-input v-model="model"
                 v-mask="['#####.##### #####.###### #####.###### # ##############', '############ ############ ############ ############']"
                 :required="required"
                 :disabled="disabled"
                 :placeholder="placeholder"
                 @input="inputDefault" ></b-input>
</template>

<script>
export default {
  props: {
    value: null,
    input: { type: Function, default: null },
    required: { default: false },
    disabled: { default: false },
    placeholder: { default: '' }
  },
  methods: {
    inputDefault: function (val) {
      if (this.input) { this.input(val) }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
